module.exports = __webpack_public_path__ + "static/media/Icono plantillas.914fd8f7.svg";